export const unauthorizedResponse = {
  code: 401,
  reason: 'Unauthorized',
  message: 'Unknown error',
};
